if (!customElements.get('kiwibit-gallery-media')) {
  customElements.define(
    'kiwibit-gallery-media',
    class KiwibitGalleryMedia extends HTMLElement {
      connectedCallback() {
        this.loadGeneration = 0;
        this.isLoading = false;
        this.hasLoaded = false;
        this.mount = this.querySelector('[data-kiwibit-gallery-media-mount]');
        this.template = this.querySelector('template[data-kiwibit-gallery-media-template]');
        if (!this.mount || !this.template) return;

        if (!('IntersectionObserver' in window)) {
          this.loadAnimatedImage();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.loadAnimatedImage();
            }
          },
          {
            root: null,
            rootMargin: this.dataset.rootMargin || '0px',
            threshold: 0.01,
          }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.loadGeneration += 1;
        this.observer?.disconnect();
        this.observer = null;
      }

      async loadAnimatedImage() {
        if (this.isLoading || this.hasLoaded || !this.mount || !this.template) return;
        this.isLoading = true;
        const loadGeneration = ++this.loadGeneration;
        const fragment = this.template.content.cloneNode(true);
        const image = fragment.querySelector('img');
        if (!image) {
          this.isLoading = false;
          return;
        }

        image.loading = 'eager';
        image.fetchPriority = 'low';
        this.mount.replaceChildren(fragment);

        try {
          if (!image.complete) {
            await new Promise((resolve, reject) => {
              image.addEventListener('load', resolve, { once: true });
              image.addEventListener('error', reject, { once: true });
            });
          } else if (!image.naturalWidth) {
            throw new Error('Animated image failed to load');
          }

          await new Promise((resolve) => {
            requestAnimationFrame(() => requestAnimationFrame(resolve));
          });

          if (loadGeneration !== this.loadGeneration || !this.isConnected) return;
          this.hasLoaded = true;
          this.classList.add('is-media-ready');
          this.observer?.disconnect();
          this.observer = null;
        } catch (_) {
          if (loadGeneration !== this.loadGeneration) return;
          this.mount.replaceChildren();
          this.classList.remove('is-media-ready');
        } finally {
          if (loadGeneration === this.loadGeneration) {
            this.isLoading = false;
          }
        }
      }
    }
  );
}
